import React, { Component } from 'react';


class PermissaoNegada extends Component {

    render() {
        return (
            <h1>Permissão negada!</h1>
        )
    }
}

export default PermissaoNegada;